import { Field, useFormikContext } from "formik";
import { FormFieldWrapper } from "../../../../components/FormComponents/FieldWrapper";
import { Checkbox, TextField } from "@mui/material";
import { hasError } from "../../../../components/FormComponents/utils";
import { ChangeEvent, useState } from "react";
import { Close } from "@mui/icons-material";


function ServicoComplementarEntry({ label, name, defaultValue }: { label: string, name: string, defaultValue: string }) {

    const { errors, values, touched, setFieldValue } = useFormikContext<any>();

    const [hasCustomValue, setHasCustomValue] = useState(!!values.servicosComplementares?.[name]?.value);

    return (
        <FormFieldWrapper label={label}>
            <div className="flex items-center justify-between">
                <Field
                    name={`servicosComplementares.${name}.applies`}
                    as={Checkbox}
                    checked={values.servicosComplementares?.[name]?.applies}
                    error={hasError({ errors, touched, name: `servicosComplementares.${name}.applies` })}
                    onChange={(e : ChangeEvent<HTMLInputElement>) => {
                        setFieldValue(`servicosComplementares.${name}.applies`, e.target.checked)
                        if(!e.target.checked) {
                            setFieldValue(`servicosComplementares.${name}.value`, null);
                            setHasCustomValue(false);
                        }
                    }}
                    variant={'outlined'}
                    label={'Aceite'}
                />
                {values?.servicosComplementares?.[name]?.applies && <>
                    {hasCustomValue ?
                        <Field
                            name={`servicosComplementares.${name}.value`}
                            as={TextField}
                            type="number"
                            error={hasError({ errors, touched, name: `servicosComplementares.${name}.value` })}
                            variant={'outlined'}
                            label={'Valor (€)'}
                        />
                        : <div className="flex items-center">
                            <div className="mr-2">{defaultValue}</div>
                            <div>
                                <Close onClick={() => setHasCustomValue(true)} />
                            </div>
                        </div>}
                </>}
            </div>
        </FormFieldWrapper>
    )


}



export function ServicosComplementaresForm() {

    const { errors, values, touched, setFieldValue } = useFormikContext<any>();



    return (<div className="p-2 mt-2">
        <div className="font-bold ">Serviços complementares</div>
        <div className="p-1">
            <ServicoComplementarEntry
                label={"Montagem"}
                name={"montagem"}
                defaultValue={'15%'}
            />

            <ServicoComplementarEntry
                label={"Gravação laser"}
                name={"gravacaoLaser"}
                defaultValue={'1€/peça'}
            />

            <ServicoComplementarEntry
                label={"Relatório dimensional"}
                name={"relatorioDimensional"}
                defaultValue="15%"
            />

            <ServicoComplementarEntry
                label={"Desenvolvimento/Projeto"}
                name={"desenvolvimentoOuProjeto"}
                defaultValue={'35%'}
            />

            <ServicoComplementarEntry
                label={"Implementação"}
                name={"implementacao"}
                defaultValue={'15% + Transporte'}
            />

        </div>
    </div>)



}